import Nav from '@mc/navigation'
import { Locations, Product } from '@mc/track-event'
import { AtWorkLink } from 'components/Navigation/shared/AtWorkLink'
import { CertificatesLink } from 'components/Navigation/shared/CertificatesLink'
import { OnCallLink } from 'components/Navigation/shared/OnCallLink'
import { MasterClassLink } from './MasterClassLink'
import classes from './TopNavigation.module.scss'

export const TopNavigation = ({
  contained = false,
  className,
  showOnCallLink = false,
  showAtWorkLink = false,
  product = Product.MASTERCLASS,
}: {
  contained?: boolean
  className?: string
  showOnCallLink?: boolean
  showAtWorkLink?: boolean
  product?: (typeof Product)[keyof typeof Product]
}) => (
  <Nav
    background='transparent'
    className={`mc-bg-neutral-1000 d-none d-lg-block mc-theme-dark mc-py-1 ${className}`}
    navChildClassName={`flex-nowrap ${classes.navChild}`}
    contained={contained}
  >
    <Nav.Left>
      <MasterClassLink
        className='mc-text-x-small mc-text--bold mc-ml-0'
        location={Locations.UTILITY_NAVIGATION}
        product={product}
      />
      <CertificatesLink
        className='mc-text-x-small mc-text--bold mc-ml-8'
        location={Locations.UTILITY_NAVIGATION}
        product={product}
      />
      {showOnCallLink && (
        <OnCallLink
          className='mc-text-x-small mc-text--bold mc-ml-8'
          location={Locations.UTILITY_NAVIGATION}
          product={product}
        />
      )}
      {showAtWorkLink && (
        <AtWorkLink
          className='mc-text-x-small mc-text--bold mc-ml-8'
          location={Locations.UTILITY_NAVIGATION}
          product={product}
        />
      )}
    </Nav.Left>
  </Nav>
)
